export class GameConstants {
    static readonly SCATTER_SYMBOL_ID = 12;
    static readonly SPECIAL_SYMBOL_ID = 13;
    static readonly BLOCKED_SYMBOL_ID = 20;
    static readonly BACKGROUND_SIZE = 2048;
    static readonly BACKGROUND_SIZE_HIGHER = 3000;
    static readonly GAME_RES_WIDTH = 1920;
    static readonly GAME_RES_HEIGHT = 1080;
    static readonly BIG_WIN_COUNTER_OFFSET = 265;
    static readonly FEATURE_TYPE_1 = "scarabWin";
    static readonly FEATURE_TYPE_2 = "scarabCollect";
    static readonly BASEGAME_SCARAB_REWARD : Record<number, number>[]  = [{5: 5}, {6: 10}, {7: 20}, {8: 50}, {9: 100}, {10: 1000}, {11: 5000}, {12: 10000}];
    static readonly FREESPIN_SCARAB_REWARD :  Record<number, number>[] = [{5: 5}, {10: 10}, {15: 20}, {20: 50}, {25: 100}, {30: 1000}, {40: 5000}, {50: 10000}];
}
